import Vue from 'vue';
import { getNPMILabel } from './SegmentCorrelation.vue';
import InteractionMenu from 'src/components/widgets/InteractionMenu.vue';
export default Vue.extend({
    components: { InteractionMenu },
    props: {
        row: { type: Object, required: true },
        clicked: { type: Boolean, required: true },
    },
    data() {
        return {
            getNPMILabel,
        };
    },
    methods: {
        getEl() {
            return this.$refs.row;
        }
    }
});
